import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Lock, User as UserIcon, ArrowLeft } from 'lucide-react';
import api, { setAuthToken } from '../utils/api';
import { toast } from 'sonner';

const AdminLoginPage = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post('/auth/login', credentials);
      setAuthToken(response.data.access_token);
      localStorage.setItem('admin_user', JSON.stringify(response.data.user));
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('Invalid credentials. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FFFDF9] flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_ae32ccb0-3c5f-414a-b46c-cfd49c04a91f/artifacts/kjz9vxob_556719997_17915806479189788_8925177708886366329_n.jpg"
            alt="Ahmedabad NX"
            className="h-20 w-20 mx-auto mb-4"
          />
          <h1 className="font-heading text-3xl font-bold text-[#2A0000]">Admin Login</h1>
          <p className="text-[#2C2C2C] mt-2">Access your dashboard</p>
        </div>

        <div className="bg-white p-8 rounded-sm border border-[#E5A93C]/20 shadow-lg">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-[#2C2C2C] mb-2">
                Username
              </label>
              <div className="relative">
                <UserIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                  type="text"
                  value={credentials.username}
                  onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                  required
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-[#E5A93C]"
                  placeholder="Enter username"
                  data-testid="admin-username"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-[#2C2C2C] mb-2">
                Password
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                  type="password"
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  required
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-[#E5A93C]"
                  placeholder="Enter password"
                  data-testid="admin-password"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full btn-primary"
              data-testid="admin-login-submit"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>

        {/* Back to home */}
        <div className="mt-6 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-[#2A0000]/60 hover:text-[#2A0000] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;